<pxw-alert type="danger" size="sm" display="inline-block"> {{ message() }} </pxw-alert>
<pxw-form-validation
  name="outOfDeliveryZoneShippingNotAllowed"
  [displayErrors]="isFormSubmitted()"
  [ngModel]="false"
  [requiredTrue]="true"
  [messages]="{
    required: '',
  }"
/>
